import React, { useState } from 'react';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '../../components/ui/Card';
import { Input } from '../../components/ui/Input';
import { Button } from '../../components/ui/Button';
export function TipCalculator() {
  const [billAmount, setBillAmount] = useState('100');
  const [tipPercent, setTipPercent] = useState('18');
  const [numPeople, setNumPeople] = useState('1');
  const [result, setResult] = useState<{
    tipAmount: number;
    total: number;
    perPerson: number;
  } | null>(null);
  const calculate = () => {
    const bill = parseFloat(billAmount);
    const tip = parseFloat(tipPercent) / 100;
    const people = parseInt(numPeople);
    const tipAmount = bill * tip;
    const total = bill + tipAmount;
    const perPerson = total / people;
    setResult({
      tipAmount: Math.round(tipAmount * 100) / 100,
      total: Math.round(total * 100) / 100,
      perPerson: Math.round(perPerson * 100) / 100
    });
  };
  const quickTip = (percent: number) => {
    setTipPercent(percent.toString());
  };
  return <div className="container mx-auto px-4 py-8 max-w-2xl" data-id="element-354">
      <div className="mb-8" data-id="element-355">
        <h1 className="text-4xl font-bold mb-2" data-id="element-356">Tip Calculator</h1>
        <p className="text-muted-foreground" data-id="element-357">
          Calculate tips and split bills easily
        </p>
      </div>

      <Card data-id="element-358">
        <CardHeader data-id="element-359">
          <CardTitle data-id="element-360">Bill Details</CardTitle>
          <CardDescription data-id="element-361">Enter your bill information</CardDescription>
        </CardHeader>
        <CardContent className="space-y-4" data-id="element-362">
          <Input type="number" label="Bill Amount ($)" value={billAmount} onChange={e => setBillAmount(e.target.value)} placeholder="100.00" step="0.01" data-id="element-363" />

          <div data-id="element-364">
            <label className="block text-sm font-medium mb-1.5" data-id="element-365">
              Tip Percentage
            </label>
            <div className="flex gap-2 mb-2" data-id="element-366">
              {[15, 18, 20, 25].map(percent => <Button key={percent} variant={tipPercent === percent.toString() ? 'primary' : 'outline'} onClick={() => quickTip(percent)} className="flex-1" data-id="element-367">
                  {percent}%
                </Button>)}
            </div>
            <Input type="number" value={tipPercent} onChange={e => setTipPercent(e.target.value)} placeholder="18" step="1" data-id="element-368" />
          </div>

          <Input type="number" label="Number of People" value={numPeople} onChange={e => setNumPeople(e.target.value)} placeholder="1" min="1" data-id="element-369" />

          <Button onClick={calculate} className="w-full" data-id="element-370">
            Calculate Tip
          </Button>

          {result && <div className="mt-6 space-y-3" data-id="element-371">
              <div className="p-4 bg-primary/10 rounded-lg" data-id="element-372">
                <p className="text-sm text-muted-foreground mb-1" data-id="element-373">Tip Amount</p>
                <p className="text-2xl font-bold text-primary" data-id="element-374">
                  ${result.tipAmount.toFixed(2)}
                </p>
              </div>
              <div className="flex justify-between items-center p-3 bg-muted rounded-lg" data-id="element-375">
                <span className="text-sm font-medium" data-id="element-376">Total Bill</span>
                <span className="font-semibold" data-id="element-377">
                  ${result.total.toFixed(2)}
                </span>
              </div>
              <div className="flex justify-between items-center p-3 bg-muted rounded-lg" data-id="element-378">
                <span className="text-sm font-medium" data-id="element-379">Per Person</span>
                <span className="font-semibold" data-id="element-380">
                  ${result.perPerson.toFixed(2)}
                </span>
              </div>
            </div>}
        </CardContent>
      </Card>
    </div>;
}